import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const CartoonTest = () => {
  const [bounceChar, setBounceChar] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);

  const triggerBounce = (id) => {
    setBounceChar(id);
    setTimeout(() => setBounceChar(null), 1000);
  };

  const triggerConfetti = () => {
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 3000);
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
      padding: '40px 20px',
      fontFamily: "'Comic Sans MS', 'Chalkboard SE', cursive",
      overflow: 'hidden',
      position: 'relative'
    }}>
      {/* Floating clouds background */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden', pointerEvents: 'none' }}>
        {[...Array(5)].map((_, i) => (
          <div key={i} style={{
            position: 'absolute',
            top: `${10 + i * 15}%`,
            left: `-200px`,
            width: '180px',
            height: '60px',
            background: 'rgba(255,255,255,0.15)',
            borderRadius: '50px',
            animation: `cloudFloat ${15 + i * 5}s linear infinite`,
            animationDelay: `${i * 3}s`
          }}>
            <div style={{
              position: 'absolute', top: '-20px', left: '40px',
              width: '80px', height: '50px',
              background: 'rgba(255,255,255,0.15)',
              borderRadius: '50px'
            }}/>
          </div>
        ))}
      </div>

      {/* Confetti overlay */}
      {showConfetti && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none', zIndex: 100 }}>
          {[...Array(50)].map((_, i) => (
            <div key={i} style={{
              position: 'absolute',
              top: '-10px',
              left: `${Math.random() * 100}%`,
              width: `${8 + Math.random() * 8}px`,
              height: `${8 + Math.random() * 8}px`,
              background: ['#ff6b6b','#ffd93d','#6bcb77','#4d96ff','#ff6bb5','#845ec2'][Math.floor(Math.random()*6)],
              borderRadius: Math.random() > 0.5 ? '50%' : '2px',
              animation: `confettiFall ${2 + Math.random() * 3}s ease-in forwards`,
              animationDelay: `${Math.random() * 0.5}s`,
              transform: `rotate(${Math.random() * 360}deg)`
            }}/>
          ))}
        </div>
      )}

      <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ 
            fontSize: '3rem', color: '#fff', textShadow: '3px 3px 0 rgba(0,0,0,0.2)',
            margin: 0, animation: 'titleBounce 2s ease-in-out infinite'
          }}>
            Ashop Cartoon Gang
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.2rem', marginTop: '8px' }}>
            Click on any character to see them in action!
          </p>
          <button 
            onClick={triggerConfetti}
            style={{
              marginTop: '16px', padding: '12px 32px', fontSize: '1rem',
              background: '#ffd93d', color: '#333', border: 'none', borderRadius: '50px',
              cursor: 'pointer', fontWeight: 'bold', fontFamily: 'inherit',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
              transition: 'transform 0.2s'
            }}
            onMouseEnter={e => e.target.style.transform = 'scale(1.1)'}
            onMouseLeave={e => e.target.style.transform = 'scale(1)'}
            data-testid="party-btn"
          >
            Party Time!
          </button>
          <Link to="/admin" style={{
            display: 'inline-block', marginLeft: '12px', marginTop: '16px', padding: '12px 32px', fontSize: '1rem',
            background: 'rgba(255,255,255,0.2)', color: '#fff', border: '2px solid rgba(255,255,255,0.5)', borderRadius: '50px',
            cursor: 'pointer', fontWeight: 'bold', fontFamily: 'inherit', textDecoration: 'none',
            transition: 'transform 0.2s'
          }}>
            Back to Admin
          </Link>
        </div>

        {/* Character Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '30px' }}>

          {/* CHARACTER 1: Boxy the Package */}
          <div 
            onClick={() => triggerBounce('boxy')}
            style={{
              background: 'rgba(255,255,255,0.95)', borderRadius: '24px', padding: '30px',
              textAlign: 'center', cursor: 'pointer', transition: 'transform 0.3s, box-shadow 0.3s',
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              transform: bounceChar === 'boxy' ? 'scale(1.1)' : 'scale(1)',
              animation: 'cardEntrance 0.6s ease-out'
            }}
            data-testid="char-boxy"
          >
            <svg viewBox="0 0 200 200" width="180" height="180" style={{ margin: '0 auto', display: 'block' }}>
              {/* Package body */}
              <rect x="40" y="60" width="120" height="100" rx="8" fill="#D2691E" stroke="#8B4513" strokeWidth="3"/>
              <line x1="100" y1="60" x2="100" y2="160" stroke="#8B4513" strokeWidth="2" strokeDasharray="5,5"/>
              <line x1="40" y1="110" x2="160" y2="110" stroke="#8B4513" strokeWidth="2" strokeDasharray="5,5"/>
              {/* Tape */}
              <rect x="80" y="50" width="40" height="20" rx="3" fill="#F4D03F" opacity="0.9"/>
              {/* Eyes */}
              <g style={{ animation: bounceChar === 'boxy' ? 'eyeBlink 0.3s ease' : 'none' }}>
                <circle cx="80" cy="90" r="12" fill="white"/>
                <circle cx="120" cy="90" r="12" fill="white"/>
                <circle cx="83" cy="90" r="6" fill="#333">
                  <animate attributeName="cx" values="83;86;83;80;83" dur="3s" repeatCount="indefinite"/>
                </circle>
                <circle cx="123" cy="90" r="6" fill="#333">
                  <animate attributeName="cx" values="123;126;123;120;123" dur="3s" repeatCount="indefinite"/>
                </circle>
              </g>
              {/* Smile */}
              <path d="M 80 125 Q 100 145 120 125" fill="none" stroke="#333" strokeWidth="3" strokeLinecap="round">
                <animate attributeName="d" values="M 80 125 Q 100 145 120 125;M 80 128 Q 100 150 120 128;M 80 125 Q 100 145 120 125" dur="2s" repeatCount="indefinite"/>
              </path>
              {/* Blush */}
              <circle cx="68" cy="120" r="8" fill="#FFB6C1" opacity="0.5"/>
              <circle cx="132" cy="120" r="8" fill="#FFB6C1" opacity="0.5"/>
              {/* Arms */}
              <g style={{ transformOrigin: '40px 100px', animation: bounceChar === 'boxy' ? 'waveArm 0.5s ease 2' : 'none' }}>
                <path d="M 40 100 Q 20 80 15 95" fill="none" stroke="#D2691E" strokeWidth="6" strokeLinecap="round"/>
                <circle cx="15" cy="95" r="6" fill="#F4D03F"/>
              </g>
              <g style={{ transformOrigin: '160px 100px', animation: bounceChar === 'boxy' ? 'waveArmR 0.5s ease 2' : 'none' }}>
                <path d="M 160 100 Q 180 80 185 95" fill="none" stroke="#D2691E" strokeWidth="6" strokeLinecap="round"/>
                <circle cx="185" cy="95" r="6" fill="#F4D03F"/>
              </g>
              {/* Legs */}
              <rect x="70" y="158" width="16" height="25" rx="8" fill="#8B4513">
                <animate attributeName="height" values="25;20;25" dur="1s" repeatCount="indefinite"/>
              </rect>
              <rect x="114" y="158" width="16" height="25" rx="8" fill="#8B4513">
                <animate attributeName="height" values="25;20;25" dur="1s" begin="0.5s" repeatCount="indefinite"/>
              </rect>
            </svg>
            <h3 style={{ color: '#D2691E', fontSize: '1.5rem', margin: '10px 0 4px' }}>Boxy</h3>
            <p style={{ color: '#888', fontSize: '0.9rem', margin: 0 }}>The Happy Package</p>
            <span style={{ 
              display: 'inline-block', marginTop: '8px', padding: '4px 12px', 
              background: '#FFF3CD', color: '#856404', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold'
            }}>Use: Package Received!</span>
          </div>

          {/* CHARACTER 2: Speedy the Delivery Runner */}
          <div 
            onClick={() => triggerBounce('speedy')}
            style={{
              background: 'rgba(255,255,255,0.95)', borderRadius: '24px', padding: '30px',
              textAlign: 'center', cursor: 'pointer', transition: 'transform 0.3s, box-shadow 0.3s',
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              transform: bounceChar === 'speedy' ? 'scale(1.1)' : 'scale(1)',
              animation: 'cardEntrance 0.6s ease-out 0.1s both'
            }}
            data-testid="char-speedy"
          >
            <svg viewBox="0 0 200 200" width="180" height="180" style={{ margin: '0 auto', display: 'block' }}>
              {/* Body */}
              <ellipse cx="100" cy="130" rx="30" ry="35" fill="#4ECDC4"/>
              {/* Head */}
              <circle cx="100" cy="70" r="30" fill="#FFE0BD"/>
              {/* Cap */}
              <path d="M 70 65 Q 100 30 130 65" fill="#E74C3C"/>
              <rect x="65" y="62" width="70" height="8" rx="4" fill="#C0392B"/>
              <circle cx="100" cy="42" r="5" fill="#E74C3C"/>
              {/* Eyes */}
              <g>
                <circle cx="88" cy="68" r="8" fill="white"/>
                <circle cx="112" cy="68" r="8" fill="white"/>
                <circle cx="90" cy="68" r="4" fill="#333">
                  <animate attributeName="cx" values="90;93;90" dur="0.3s" repeatCount="indefinite"/>
                </circle>
                <circle cx="114" cy="68" r="4" fill="#333">
                  <animate attributeName="cx" values="114;117;114" dur="0.3s" repeatCount="indefinite"/>
                </circle>
              </g>
              {/* Determined mouth */}
              <path d="M 90 85 L 110 85" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
              {/* Sweat drop */}
              <ellipse cx="135" cy="60" rx="4" ry="6" fill="#87CEEB" opacity="0.8">
                <animate attributeName="cy" values="55;65;55" dur="1s" repeatCount="indefinite"/>
                <animate attributeName="opacity" values="0.8;0;0.8" dur="1s" repeatCount="indefinite"/>
              </ellipse>
              {/* Running legs */}
              <g>
                <line x1="85" y1="162" x2="60" y2="185" stroke="#FFE0BD" strokeWidth="8" strokeLinecap="round">
                  <animate attributeName="x2" values="60;75;60" dur="0.4s" repeatCount="indefinite"/>
                </line>
                <line x1="115" y1="162" x2="140" y2="185" stroke="#FFE0BD" strokeWidth="8" strokeLinecap="round">
                  <animate attributeName="x2" values="140;125;140" dur="0.4s" repeatCount="indefinite"/>
                </line>
              </g>
              {/* Arms with package */}
              <line x1="75" y1="120" x2="50" y2="100" stroke="#FFE0BD" strokeWidth="6" strokeLinecap="round">
                <animate attributeName="x2" values="50;45;50" dur="0.4s" repeatCount="indefinite"/>
              </line>
              <rect x="35" y="88" width="20" height="16" rx="3" fill="#D2691E" stroke="#8B4513" strokeWidth="1.5">
                <animate attributeName="y" values="88;85;88" dur="0.4s" repeatCount="indefinite"/>
              </rect>
              {/* Speed lines */}
              <line x1="30" y1="120" x2="10" y2="120" stroke="#999" strokeWidth="2" opacity="0.5">
                <animate attributeName="opacity" values="0.5;0;0.5" dur="0.3s" repeatCount="indefinite"/>
              </line>
              <line x1="25" y1="130" x2="5" y2="130" stroke="#999" strokeWidth="2" opacity="0.3">
                <animate attributeName="opacity" values="0.3;0;0.3" dur="0.3s" begin="0.1s" repeatCount="indefinite"/>
              </line>
              <line x1="30" y1="140" x2="15" y2="140" stroke="#999" strokeWidth="2" opacity="0.4">
                <animate attributeName="opacity" values="0.4;0;0.4" dur="0.3s" begin="0.2s" repeatCount="indefinite"/>
              </line>
            </svg>
            <h3 style={{ color: '#4ECDC4', fontSize: '1.5rem', margin: '10px 0 4px' }}>Speedy</h3>
            <p style={{ color: '#888', fontSize: '0.9rem', margin: 0 }}>The Delivery Runner</p>
            <span style={{ 
              display: 'inline-block', marginTop: '8px', padding: '4px 12px', 
              background: '#D4EDDA', color: '#155724', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold'
            }}>Use: Out for Delivery</span>
          </div>

          {/* CHARACTER 3: Stella the Star Rater */}
          <div 
            onClick={() => triggerBounce('stella')}
            style={{
              background: 'rgba(255,255,255,0.95)', borderRadius: '24px', padding: '30px',
              textAlign: 'center', cursor: 'pointer', transition: 'transform 0.3s, box-shadow 0.3s',
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              transform: bounceChar === 'stella' ? 'scale(1.1)' : 'scale(1)',
              animation: 'cardEntrance 0.6s ease-out 0.2s both'
            }}
            data-testid="char-stella"
          >
            <svg viewBox="0 0 200 200" width="180" height="180" style={{ margin: '0 auto', display: 'block' }}>
              {/* Star body */}
              <polygon points="100,20 120,75 180,80 135,115 150,175 100,145 50,175 65,115 20,80 80,75" 
                fill="#FFD700" stroke="#FFA500" strokeWidth="2">
                <animate attributeName="points" 
                  values="100,20 120,75 180,80 135,115 150,175 100,145 50,175 65,115 20,80 80,75;
                          100,25 118,77 175,82 133,117 148,173 100,148 52,173 67,117 25,82 82,77;
                          100,20 120,75 180,80 135,115 150,175 100,145 50,175 65,115 20,80 80,75" 
                  dur="3s" repeatCount="indefinite"/>
              </polygon>
              {/* Face */}
              {/* Eyes */}
              <circle cx="85" cy="85" r="8" fill="white"/>
              <circle cx="115" cy="85" r="8" fill="white"/>
              <circle cx="87" cy="85" r="4" fill="#333">
                <animate attributeName="r" values="4;1;4" dur="3s" repeatCount="indefinite"/>
              </circle>
              <circle cx="117" cy="85" r="4" fill="#333">
                <animate attributeName="r" values="4;1;4" dur="3s" repeatCount="indefinite"/>
              </circle>
              {/* Eyelashes */}
              <line x1="78" y1="78" x2="75" y2="72" stroke="#333" strokeWidth="1.5"/>
              <line x1="82" y1="76" x2="80" y2="70" stroke="#333" strokeWidth="1.5"/>
              <line x1="118" y1="76" x2="120" y2="70" stroke="#333" strokeWidth="1.5"/>
              <line x1="122" y1="78" x2="125" y2="72" stroke="#333" strokeWidth="1.5"/>
              {/* Cute smile */}
              <path d="M 85 105 Q 100 125 115 105" fill="none" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
              {/* Blush */}
              <circle cx="72" cy="100" r="7" fill="#FFB6C1" opacity="0.6"/>
              <circle cx="128" cy="100" r="7" fill="#FFB6C1" opacity="0.6"/>
              {/* Sparkles around */}
              <g>
                <text x="170" y="50" fontSize="16" fill="#FFD700" style={{ animation: 'sparkle 1s infinite' }}>*</text>
                <text x="20" y="45" fontSize="20" fill="#FFD700" style={{ animation: 'sparkle 1s infinite 0.3s' }}>*</text>
                <text x="160" y="170" fontSize="14" fill="#FFD700" style={{ animation: 'sparkle 1s infinite 0.6s' }}>*</text>
                <text x="30" y="165" fontSize="18" fill="#FFD700" style={{ animation: 'sparkle 1s infinite 0.9s' }}>*</text>
              </g>
            </svg>
            <h3 style={{ color: '#FFD700', fontSize: '1.5rem', margin: '10px 0 4px', textShadow: '1px 1px 0 #ddd' }}>Stella</h3>
            <p style={{ color: '#888', fontSize: '0.9rem', margin: 0 }}>The Star Rater</p>
            <span style={{ 
              display: 'inline-block', marginTop: '8px', padding: '4px 12px', 
              background: '#FFF3CD', color: '#856404', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold'
            }}>Use: Customer Rating</span>
          </div>

          {/* CHARACTER 4: Scannie the Scanner */}
          <div 
            onClick={() => triggerBounce('scannie')}
            style={{
              background: 'rgba(255,255,255,0.95)', borderRadius: '24px', padding: '30px',
              textAlign: 'center', cursor: 'pointer', transition: 'transform 0.3s, box-shadow 0.3s',
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              transform: bounceChar === 'scannie' ? 'scale(1.1)' : 'scale(1)',
              animation: 'cardEntrance 0.6s ease-out 0.3s both'
            }}
            data-testid="char-scannie"
          >
            <svg viewBox="0 0 200 200" width="180" height="180" style={{ margin: '0 auto', display: 'block' }}>
              {/* Phone body */}
              <rect x="55" y="30" width="90" height="150" rx="14" fill="#333" stroke="#555" strokeWidth="2"/>
              <rect x="62" y="45" width="76" height="110" rx="4" fill="#87CEEB"/>
              {/* Scan line */}
              <rect x="62" y="80" width="76" height="3" fill="#FF0000" opacity="0.8">
                <animate attributeName="y" values="45;150;45" dur="2s" repeatCount="indefinite"/>
              </rect>
              {/* Face on screen */}
              <circle cx="85" cy="90" r="7" fill="white"/>
              <circle cx="115" cy="90" r="7" fill="white"/>
              <circle cx="87" cy="90" r="3.5" fill="#333"/>
              <circle cx="117" cy="90" r="3.5" fill="#333"/>
              <path d="M 88 110 Q 100 122 112 110" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round"/>
              {/* Camera lens on top */}
              <circle cx="100" cy="38" r="5" fill="#555"/>
              <circle cx="100" cy="38" r="3" fill="#333"/>
              <circle cx="101" cy="37" r="1" fill="white"/>
              {/* Little arms */}
              <path d="M 55 100 Q 30 85 25 100" fill="none" stroke="#333" strokeWidth="5" strokeLinecap="round">
                <animate attributeName="d" values="M 55 100 Q 30 85 25 100;M 55 100 Q 30 75 20 85;M 55 100 Q 30 85 25 100" dur="2s" repeatCount="indefinite"/>
              </path>
              <path d="M 145 100 Q 170 85 175 100" fill="none" stroke="#333" strokeWidth="5" strokeLinecap="round">
                <animate attributeName="d" values="M 145 100 Q 170 85 175 100;M 145 100 Q 170 75 180 85;M 145 100 Q 170 85 175 100" dur="2s" begin="0.3s" repeatCount="indefinite"/>
              </path>
              {/* Little feet */}
              <ellipse cx="82" cy="182" rx="12" ry="6" fill="#555">
                <animate attributeName="rx" values="12;14;12" dur="1s" repeatCount="indefinite"/>
              </ellipse>
              <ellipse cx="118" cy="182" rx="12" ry="6" fill="#555">
                <animate attributeName="rx" values="12;14;12" dur="1s" begin="0.5s" repeatCount="indefinite"/>
              </ellipse>
              {/* Barcode being scanned */}
              {[0,1,2,3,4,5,6].map(i => (
                <rect key={i} x={70 + i*8} y="120" width={i%2===0 ? 4 : 2} height="20" fill="#333" opacity="0.6"/>
              ))}
            </svg>
            <h3 style={{ color: '#333', fontSize: '1.5rem', margin: '10px 0 4px' }}>Scannie</h3>
            <p style={{ color: '#888', fontSize: '0.9rem', margin: 0 }}>The Smart Scanner</p>
            <span style={{ 
              display: 'inline-block', marginTop: '8px', padding: '4px 12px', 
              background: '#D6EAF8', color: '#1B4F72', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold'
            }}>Use: OCR Scanning</span>
          </div>

          {/* CHARACTER 5: Checky the Checkmark */}
          <div 
            onClick={() => triggerBounce('checky')}
            style={{
              background: 'rgba(255,255,255,0.95)', borderRadius: '24px', padding: '30px',
              textAlign: 'center', cursor: 'pointer', transition: 'transform 0.3s, box-shadow 0.3s',
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              transform: bounceChar === 'checky' ? 'scale(1.1)' : 'scale(1)',
              animation: 'cardEntrance 0.6s ease-out 0.4s both'
            }}
            data-testid="char-checky"
          >
            <svg viewBox="0 0 200 200" width="180" height="180" style={{ margin: '0 auto', display: 'block' }}>
              {/* Circle body */}
              <circle cx="100" cy="100" r="60" fill="#27AE60" stroke="#1E8449" strokeWidth="3"/>
              {/* Checkmark shape as body */}
              <path d="M 65 100 L 90 125 L 140 70" fill="none" stroke="white" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round">
                <animate attributeName="stroke-dashoffset" values="150;0;0" dur="1.5s" repeatCount="indefinite"/>
                <animate attributeName="stroke-dasharray" values="0 150;150 0;150 0" dur="1.5s" repeatCount="indefinite"/>
              </path>
              {/* Eyes on the checkmark */}
              <circle cx="80" cy="88" r="7" fill="white"/>
              <circle cx="105" cy="78" r="7" fill="white"/>
              <circle cx="82" cy="88" r="3.5" fill="#333">
                <animate attributeName="cy" values="88;86;88" dur="2s" repeatCount="indefinite"/>
              </circle>
              <circle cx="107" cy="78" r="3.5" fill="#333">
                <animate attributeName="cy" values="78;76;78" dur="2s" repeatCount="indefinite"/>
              </circle>
              {/* Smile */}
              <path d="M 92 102 Q 98 112 108 98" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              {/* Little arms */}
              <path d="M 45 80 Q 25 65 20 80" fill="none" stroke="#27AE60" strokeWidth="5" strokeLinecap="round">
                <animate attributeName="d" values="M 45 80 Q 25 65 20 80;M 45 80 Q 20 50 15 60;M 45 80 Q 25 65 20 80" dur="1.5s" repeatCount="indefinite"/>
              </path>
              <path d="M 155 80 Q 175 65 180 80" fill="none" stroke="#27AE60" strokeWidth="5" strokeLinecap="round">
                <animate attributeName="d" values="M 155 80 Q 175 65 180 80;M 155 80 Q 180 50 185 60;M 155 80 Q 175 65 180 80" dur="1.5s" begin="0.3s" repeatCount="indefinite"/>
              </path>
              {/* Feet */}
              <ellipse cx="85" cy="163" rx="10" ry="5" fill="#1E8449"/>
              <ellipse cx="115" cy="163" rx="10" ry="5" fill="#1E8449"/>
              {/* Thumbs up sparkle */}
              <text x="165" y="55" fontSize="24" fill="#FFD700" style={{ animation: 'sparkle 1.5s infinite' }}>+</text>
            </svg>
            <h3 style={{ color: '#27AE60', fontSize: '1.5rem', margin: '10px 0 4px' }}>Checky</h3>
            <p style={{ color: '#888', fontSize: '0.9rem', margin: 0 }}>The Pickup Confirmer</p>
            <span style={{ 
              display: 'inline-block', marginTop: '8px', padding: '4px 12px', 
              background: '#D4EDDA', color: '#155724', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold'
            }}>Use: Pickup Confirmed!</span>
          </div>

          {/* CHARACTER 6: Noti the Bell */}
          <div 
            onClick={() => triggerBounce('noti')}
            style={{
              background: 'rgba(255,255,255,0.95)', borderRadius: '24px', padding: '30px',
              textAlign: 'center', cursor: 'pointer', transition: 'transform 0.3s, box-shadow 0.3s',
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              transform: bounceChar === 'noti' ? 'scale(1.1)' : 'scale(1)',
              animation: 'cardEntrance 0.6s ease-out 0.5s both'
            }}
            data-testid="char-noti"
          >
            <svg viewBox="0 0 200 200" width="180" height="180" style={{ margin: '0 auto', display: 'block' }}>
              {/* Bell body */}
              <path d="M 60 120 Q 60 50 100 40 Q 140 50 140 120 L 155 130 Q 158 138 150 140 L 50 140 Q 42 138 45 130 Z" 
                fill="#F39C12" stroke="#E67E22" strokeWidth="2">
                <animateTransform attributeName="transform" type="rotate" 
                  values="0 100 40;5 100 40;-5 100 40;3 100 40;-3 100 40;0 100 40" 
                  dur="2s" repeatCount="indefinite"/>
              </path>
              {/* Clapper */}
              <circle cx="100" cy="150" r="10" fill="#E67E22"/>
              {/* Top nub */}
              <circle cx="100" cy="35" r="6" fill="#E67E22"/>
              {/* Face */}
              <circle cx="82" cy="95" r="8" fill="white"/>
              <circle cx="118" cy="95" r="8" fill="white"/>
              <circle cx="84" cy="95" r="4" fill="#333"/>
              <circle cx="120" cy="95" r="4" fill="#333"/>
              <path d="M 88 115 Q 100 128 112 115" fill="none" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
              {/* Blush */}
              <circle cx="70" cy="108" r="6" fill="#FFB6C1" opacity="0.5"/>
              <circle cx="130" cy="108" r="6" fill="#FFB6C1" opacity="0.5"/>
              {/* Sound waves */}
              <path d="M 160 90 Q 175 100 160 110" fill="none" stroke="#F39C12" strokeWidth="2" opacity="0.6">
                <animate attributeName="opacity" values="0.6;0;0.6" dur="1s" repeatCount="indefinite"/>
              </path>
              <path d="M 170 80 Q 190 100 170 120" fill="none" stroke="#F39C12" strokeWidth="2" opacity="0.4">
                <animate attributeName="opacity" values="0.4;0;0.4" dur="1s" begin="0.3s" repeatCount="indefinite"/>
              </path>
              <path d="M 40 90 Q 25 100 40 110" fill="none" stroke="#F39C12" strokeWidth="2" opacity="0.6">
                <animate attributeName="opacity" values="0.6;0;0.6" dur="1s" begin="0.15s" repeatCount="indefinite"/>
              </path>
              {/* Exclamation */}
              <text x="92" y="78" fontSize="18" fill="#E74C3C" fontWeight="bold" style={{ animation: 'sparkle 0.8s infinite' }}>!</text>
            </svg>
            <h3 style={{ color: '#F39C12', fontSize: '1.5rem', margin: '10px 0 4px' }}>Noti</h3>
            <p style={{ color: '#888', fontSize: '0.9rem', margin: 0 }}>The Alert Bell</p>
            <span style={{ 
              display: 'inline-block', marginTop: '8px', padding: '4px 12px', 
              background: '#FDEBD0', color: '#784212', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold'
            }}>Use: New Notification!</span>
          </div>

        </div>

        {/* Usage Guide */}
        <div style={{ 
          marginTop: '40px', background: 'rgba(255,255,255,0.9)', borderRadius: '24px', 
          padding: '30px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)' 
        }}>
          <h2 style={{ color: '#333', textAlign: 'center', marginBottom: '20px' }}>How These Characters Can Be Used</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
            {[
              { char: 'Boxy', action: 'Pops up when a new package is added', color: '#D2691E' },
              { char: 'Speedy', action: 'Appears during scanning/loading states', color: '#4ECDC4' },
              { char: 'Stella', action: 'Shows up on the customer rating screen', color: '#FFD700' },
              { char: 'Scannie', action: 'Animates during OCR label scanning', color: '#333' },
              { char: 'Checky', action: 'Celebrates when a pickup is confirmed', color: '#27AE60' },
              { char: 'Noti', action: 'Rings when admin gets a notification', color: '#F39C12' },
            ].map((item, i) => (
              <div key={i} style={{ 
                padding: '16px', borderRadius: '12px', background: '#f8f9fa',
                borderLeft: `4px solid ${item.color}` 
              }}>
                <strong style={{ color: item.color }}>{item.char}</strong>
                <p style={{ margin: '4px 0 0', color: '#666', fontSize: '0.9rem' }}>{item.action}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes cloudFloat {
          0% { transform: translateX(0); }
          100% { transform: translateX(calc(100vw + 400px)); }
        }
        @keyframes titleBounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        @keyframes cardEntrance {
          from { opacity: 0; transform: translateY(40px) scale(0.9); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes sparkle {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.3; transform: scale(1.5); }
        }
        @keyframes waveArm {
          0%, 100% { transform: rotate(0deg); }
          50% { transform: rotate(-30deg); }
        }
        @keyframes waveArmR {
          0%, 100% { transform: rotate(0deg); }
          50% { transform: rotate(30deg); }
        }
        @keyframes eyeBlink {
          0%, 100% { transform: scaleY(1); }
          50% { transform: scaleY(0.1); }
        }
        @keyframes confettiFall {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default CartoonTest;
